module.exports = __webpack_public_path__ + "40ee36056f5d70967e9695e101a78127.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-bold.ttf
// module id = 96
// module chunks = 0